import { useState } from 'react'
import MaskedInputService from 'services/maskedInput'
import businessDataValidator from 'validators/businessDataValidator'
import AddPictureModal from 'pages//Modals/AddPictureModal'
import cutileiLogo from 'icons/cutilei-logo.png'
import { MdNavigateNext } from 'react-icons/md'
import { Formik } from 'formik'

import {
  Form,
  Row,
  Button,
  SubTitle,
  InfoText,
  FormField,
  WarningText,
  ImageContainer,
  Image,
  Input,
  MaskedInput
} from '../styles'

export default function CompanyDataForm ({
  companyData = {},
  onFormSubmitted: handleFormSubmitted = () => null
}) {
  const [showPictureDialog, setShowPictureDialog] = useState (false)

  const handlePreventEvent = e => e.preventDefault ()
  const togglePictureDialog = () => setShowPictureDialog (!showPictureDialog)

  return (
    <Formik
      validationSchema={businessDataValidator}
      validateOnChange={false}
      validateOnBlur={true}
      initialValues={{
        'logo': companyData.logo,
        'name': companyData.name,
        'corporate_name': companyData.corporate_name,
        'use_cnpj': true,
        'cnpj': companyData.cnpj,
        'email': companyData.email,
        'email_confirmation': companyData.email_confirmation,
        'phone': companyData.phone,
        'cellphone': companyData.cellphone
      }}
      onSubmit={values => handleFormSubmitted (values)}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        handleChange,
        handleBlur,
        handleSubmit
      }) => {
        const handleChangePicture = newPictureUrl => {
          setFieldValue ('logo', newPictureUrl)
        }

        return (
          <Form onSubmit={handleSubmit}>
            <SubTitle>Dados da empresa</SubTitle>
            <FormField style={{marginBottom: 20}}>
              <ImageContainer onClick={togglePictureDialog}>
                <Image src={values.logo?.url ?? cutileiLogo}/>
              </ImageContainer>
              <SubTitle>Adicione a logo de sua empresa</SubTitle>
              <InfoText>
                Dê preferência para uma foto em formato <b>retangular</b> com sua <b>logomarca</b>. 
              </InfoText>
            </FormField>
            <Row>
              <FormField stretch={2}>
                <Input
                  placeholder='Nome fantasia'
                  value={values.name}
                  onChange={handleChange ('name')}
                  onBlur={handleBlur ('name')}
                />
                {touched.name && errors.name && (
                  <WarningText>{errors.name}</WarningText>
                )}
              </FormField>
              <FormField stretch={2}>
                <Input
                  placeholder='Razão social'
                  value={values.corporate_name}
                  onChange={handleChange ('corporate_name')}
                  onBlur={handleBlur ('corporate_name')}
                />
                {touched.corporate_name && errors.corporate_name && (
                  <WarningText>{errors.corporate_name}</WarningText>
                )}
              </FormField>
              <FormField stretch={2}>
                <MaskedInput
                  name='cnpj'
                  placeholder='CNPJ'
                  options={{
                    blocks: [2,3,3,4,2],
                    delimiters: ['.', '.','/', '-'],
                    numericOnly: true
                  }}
                  value={values.cnpj}
                  onChange={event => MaskedInputService.handleChange (event, setFieldValue)}
                  onBlur={handleBlur ('cnpj')}
                />
                {touched.cnpj && errors.cnpj && (
                  <WarningText>{errors.cnpj}</WarningText>
                )}
              </FormField>
            </Row>
            <Row>
              <FormField stretch={2}>
                <Input
                  type='email'
                  autoComplete='off'
                  placeholder='E-mail'
                  value={values.email}
                  onCopy={handlePreventEvent} 
                  onPaste={handlePreventEvent} 
                  onCut={handlePreventEvent} 
                  onChange={handleChange ('email')}
                  onBlur={handleBlur ('email')}
                />
                {touched.email && errors.email && (
                  <WarningText>{errors.email}</WarningText>
                )}
              </FormField>
              <FormField stretch={2}>
                <Input
                  type='email'
                  autoComplete='off'
                  placeholder='Confirmar e-mail'
                  value={values.email_confirmation}
                  onCopy={handlePreventEvent} 
                  onPaste={handlePreventEvent} 
                  onCut={handlePreventEvent} 
                  onChange={handleChange ('email_confirmation')}
                  onBlur={handleBlur ('email_confirmation')}
                />
                {touched.email_confirmation && errors.email_confirmation && (
                  <WarningText>{errors.email_confirmation}</WarningText>
                )}
              </FormField>
              <FormField>
                <MaskedInput
                  name='cellphone'
                  placeholder='Celular'
                  options={{
                    blocks: [0, 2, 5, 4],
                    delimiters: ['(', ') ', '-'],
                    numericOnly: true
                  }}
                  value={values.cellphone}
                  onChange={event => MaskedInputService.handleChange (event, setFieldValue)}
                  onBlur={handleBlur ('cellphone')}
                />
                {touched.cellphone && errors.cellphone && (
                  <WarningText>{errors.cellphone}</WarningText>
                )}
              </FormField>
              <FormField>
                <MaskedInput
                  name='phone'
                  placeholder='Telefone (opcional)'
                  options={{
                    blocks: [0, 2, 4, 4],
                    delimiters: ['(', ') ', '-'],
                    numericOnly: true
                  }}
                  value={values.phone}
                  onChange={event => MaskedInputService.handleChange (event, setFieldValue)}
                  onBlur={handleBlur ('phone')}
                />
                {touched.phone && errors.phone && (
                  <WarningText>{errors.phone}</WarningText>
                )}
              </FormField>
            </Row>
            <AddPictureModal
              title='Adicionar logomarca'
              visible={showPictureDialog}
              currentImage={values.logo?.url ?? cutileiLogo}
              onConfirm={handleChangePicture}
              onClose={togglePictureDialog}
            />
            <Button type='submit'>
              <MdNavigateNext size={30}/>
            </Button>
          </Form>
        )
      }}
    </Formik>
  )
}
